import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import '../styles/Landing.css';

const Landing = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Add email to Firestore waitlist collection
      await addDoc(collection(db, 'waitlist'), {
        email: email.toLowerCase().trim(),
        timestamp: serverTimestamp(),
        source: 'landing_page'
      });
      
      setSubmitted(true);
      setEmail('');
    } catch (err) {
      console.error('Error adding to waitlist:', err);
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="landing-container">
      <div className="landing-content">
        <div className="landing-header">
          <div className="landing-logo-container">
            <img src="/logo.png" alt="CannAverum" className="landing-logo" />
          </div>
          <p className="landing-subtitle">Explore Cannabis Strain Lineages & Flavor Profiles</p>
        </div>

        <div className="landing-features">
          <div className="feature-card">
            <span className="feature-icon">🌿</span>
            <h3>Complete Lineage Trees</h3>
            <p>Trace strain ancestry back to landraces with interactive visualizations</p>
          </div>
          
          <div className="feature-card">
            <span className="feature-icon">🎨</span>
            <h3>Flavor Profiles</h3>
            <p>Discover terpene profiles and flavor combinations through psychedelic visuals</p>
          </div>
          
          <div className="feature-card">
            <span className="feature-icon">📊</span>
            <h3>Data-Driven</h3>
            <p>Built from thousands of real user reviews and strain data</p>
          </div>
        </div>

        <div className="waitlist-section">
          {!submitted ? (
            <>
              <h2>Join the Waitlist</h2>
              <p className="waitlist-description">
                Be the first to know when we launch our comprehensive cannabis strain database
              </p>
              
              <form onSubmit={handleSubmit} className="waitlist-form">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="email-input"
                  disabled={loading}
                  required
                />
                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? 'Adding...' : 'Join Waitlist'}
                </button>
              </form>
              
              {error && <p className="error-message">{error}</p>}
            </>
          ) : (
            <div className="success-message">
              <span className="success-icon">✓</span>
              <h2>You're on the list!</h2>
              <p>We'll notify you when CannAverum launches</p>
            </div>
          )}
        </div>

        <div className="landing-footer">
          <p>© 2024 CannAverum. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Landing;
